import React, { useState } from "react";
import { TextField, Button, Typography, Box, Paper } from "@mui/material";

function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePassword = (password) =>
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(password);

  const handleSignup = () => {
    const newErrors = {};

    if (!name) newErrors.name = "Name is required.";
    if (!email) newErrors.email = "Email is required.";
    else if (!validateEmail(email)) newErrors.email = "Invalid email format.";
    if (!password) newErrors.password = "Password is required.";
    else if (!validatePassword(password))
      newErrors.password =
        "Password must be at least 8 characters long, include at least one letter and one number.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Simulate API call for signup
      setTimeout(() => {
        setMessage("Signup successful! You can now log in.");
      }, 1000);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="90vh"
      bgcolor="#f5f5f5"
      p={2}
    >
      <Paper elevation={6} sx={{ padding: 4, width: "100%", maxWidth: 400, mt: 2 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Signup
        </Typography>

        <TextField
          label="Name"
          variant="outlined"
          margin="normal"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          error={!!errors.name}
          helperText={errors.name}
        />
        <TextField
          label="Email"
          variant="outlined"
          margin="normal"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={!!errors.email}
          helperText={errors.email}
        />
        <TextField
          label="Password"
          variant="outlined"
          margin="normal"
          fullWidth
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={!!errors.password}
          helperText={errors.password}
        />

        {message && (
          <Typography variant="body2" color="success" sx={{ mt: 1 }}>
            {message}
          </Typography>
        )}

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleSignup}
          sx={{
            width: "100%",
            mt: 2,
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          Signup
        </Button>
      </Paper>
    </Box>
  );
}

export default Signup;
